import { Select, SelectOption } from '@percent/lemonade';

import { CountrySelectProps } from './CountrySelect.types';
import { useCountries } from '@percent/hosted-validation-form/app/HostedForm/useCountries/useCountries';

export const CountrySelect = ({ onChange, value, placeholder, isDisabled }: CountrySelectProps) => {
  const countries = useCountries();

  const countryCodes: SelectOption[] = countries.map((country) => ({ value: country.code, label: country.name }));

  return (
    <Select
      data-testid="countrySelect"
      options={countryCodes}
      defaultValue={countryCodes.find((country) => country.value === value)}
      searchable
      placeholder={placeholder}
      disabled={isDisabled}
      onChange={onChange}
    />
  );
};
